<template>
    <div>

        <!-- summary -->
        <table>
            <tr>
                <td>ID:</td>
                <td>{{ template.contract.id }}</td>
            </tr>
            <tr>
                <td>Name:</td>
                <td>{{ template.contract.name }}</td>
            </tr>
            <tr>
                <td>Details:</td>
                <td>{{ template.contract.details }}</td>
            </tr>
            <tr>
                <td>Milestones:</td>
                <td>{{ template.contract.milestones.length }}</td>
            </tr>
            <tr>
                <td>Status:</td>
                <td>{{ template.contract.status }}</td>
            </tr>            
        </table>

        <br />

        <!-- template structure -->
        <div>
            <div v-for="milestone in template.contract.milestones" v-bind:key="milestone.id">

                <!-- milestone -->
                <div class="template-process" :class="[milestone.status]">{{ milestone.id }} {{ milestone.name }}</div>

                <!-- subprocess -->
                <div v-for="subprocess in milestone.subprocesses" v-bind:key="subprocess.id">
                    <div class="subprocess-container">
                        <div style="float: left;" class="template-process blank-process"></div>

                        <div class="template-process" :class="[subprocess.status]">{{ subprocess.id }} {{ subprocess.name }}</div>
                    </div>

                    <!-- subprocess -->
                    <div v-for="subprocess in subprocess.subprocesses" v-bind:key="subprocess.id">
                        <div class="subprocess-container">
                            <div style="float: left;" class="template-process blank-process"></div>
                            <div style="float: left;" class="template-process blank-process"></div>

                            <div class="template-process" :class="[subprocess.status]">{{ subprocess.id }} {{ subprocess.name }}</div>
                        </div>
                        
                        <!-- subprocess -->
                        <div v-for="subprocess in subprocess.subprocesses" v-bind:key="subprocess.id">
                            <div class="subprocess-container">
                                <div style="float: left;" class="template-process blank-process"></div>
                                <div style="float: left;" class="template-process blank-process"></div>
                                <div style="float: left;" class="template-process blank-process"></div>
                                
                                <div class="template-process" :class="[subprocess.status]">{{ subprocess.id }} {{ subprocess.name }}</div>
                            </div>

                        </div> 

                    </div>

                </div>

            </div>
        </div>

    </div>
</template>

<script>
    import contractTemplateTest from './contract-templates/CAR-T.json'

    export default {
        name: 'ContractTesting',
        components: {

        },
        data: function () {
            return {
                template: contractTemplateTest,
            };
        },
        props: [],
        watch: {},
        methods: {
            addOrderFlag(subprocesses) {
                
                // only process if there are subprocesses
                if(subprocesses.length != 0) {
                    for(var x = 0; x < subprocesses.length; x++) {
                        // identify First and Last Items
                        if(x == 0) {
                            console.log("  F  " + subprocesses[x].id);
                            subprocesses[x].orderFlag = "F";
                        } else if (x == (subprocesses.length -1)) {
                            console.log("  L  " + subprocesses[x].id);
                            subprocesses[x].orderFlag = "L";
                        } else {
                            console.log("  -  " + subprocesses[x].id);
                            subprocesses[x].orderFlag = null;
                        }

                        subprocesses[x].subprocesses = this.addOrderFlag(subprocesses[x].subprocesses);
                    }
                }

                return subprocesses;
            }
        },
        mounted: function () {
            // process contract templage
            console.log("PROCESSING  CONTRACT");

            // milestone
            for(var i = 0; i < this.template.contract.milestones.length; i++) {
                console.log(this.template.contract.milestones[i].id);

                this.template.contract.milestones[i].subprocesses = this.addOrderFlag(this.template.contract.milestones[i].subprocesses);

            }

        }   
    }
</script>

<style scoped>
    .template-process {
        height: 70px;
        width: 178px;
        border: 1px solid grey;
        color: grey;
        padding: 10px;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 5px;
        margin-left: 5px;
        margin-right: 5px;
    }

    .blank-process {
        border: none;
    }

    .InProgress {
        border: 1px solid blue;
        color: initial;
    }

    .Complete {
        border: 1px solid green;
        color: initial;
    }    

</style>    

